import React, { useState, useEffect } from 'react'
import FormIcon from '../Form/FormIcon'
import FormButtonIcon from '../Form/FormButtonIcon'
import SlidingForm from '../Form/SlidingForm'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import InputSelect from '../Form/input/InputSelect'
import SelectMenuItem from '../Form/input/SelectMenuItem'
import Form from '../Form/Form'
import { TYPERETURN } from '../../pages/SignIn/SignIn'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
	typographyRoot: {
		color: 'white',
		fontSize: 17,
	},
	typographyFirst: {
		color: 'white',
		fontSize: 17,
		paddingTop: 20,
	},
	inputSelectRoot: {
		marginTop: '25px',
	},
	textArea: {
		marginTop: '25px',
		minHeight: '95px',
	},
	select: {
		marginTop: 20,
	},
}))

const PlatformChoiceForm = ({ open, close, data }) => {
	const { t } = useTranslation(['user'])
	const classes = useStyles()
	const [namePlatforms, setNamePlatforms] = useState(null)
	const [roles, setRoles] = useState([])
	const [selectedPlatform, setSelectedPlatform] = useState(null)
	const [companies, setCompanies] = useState(null)

	const onSubmit = (values) => {
		const selectedRole = roles.length === 1
			? roles[0]
			: roles.find(role => role.code === values.role)

		const platformId = namePlatforms?.length === 1
			? namePlatforms[0].ptfId
			: values.platform

		const selectedCompany = companies !== null && companies.length > 0 
			? (companies.length === 1 ? companies[0].id : companies.find(company => company.id === values.company).id)
			: null
		data.selectPlatformCompany(platformId, data.authRes, selectedRole, selectedCompany)
		close()
	}

	const handleCompanyChange = (event) => {
		const companyId = event.target.value
		let listPlatforms = data.listPlatforms.filter(c => c.entId === companyId && c.statusCode !== "CompanyPlatformExpired") || []
		let companyPlatforms = [];
		listPlatforms
			.forEach(p => {
				if (!companyPlatforms.filter(cp => cp.ptfId === p.ptfId).length) {
					companyPlatforms.push({
						ptfId: p.ptfId,
						ptfNom: p.ptfNom
					})
				}
			})
		setNamePlatforms(companyPlatforms)
	}

	const handlePlatformChange = (event) => {
		const platformId = event.target.value
		setSelectedPlatform(platformId)

		const platformRoles = data.authRes.account.userPlatforms
			.find(p => p.platformId === platformId)?.accountTypes || []
		setRoles(platformRoles)
	}

	const getInitialValues = () => {
		if (data?.autoSelect && data?.listPlatforms[0]) {
			const platform = data.listPlatforms[0]
			const platformRoles = data.authRes.account.userPlatforms
				.find(p => p.platformId === platform.ptfId)?.accountTypes || []

			return {
				platform: platform.ptfId,
				...(platformRoles.length === 1 && { role: platformRoles[0].code })
			}
		}
		return {}
	}

	useEffect(() => {
		if (!data) return

		if (data.companies !== undefined && data.companies !== null) {
			if (data.companies.length === 1) {
				setNamePlatforms(data.listPlatforms.map(p => {
					return {
						ptfId: p.ptfId,
						ptfNom: p.ptfNom
					}
				}))
			}
			setCompanies(data.companies)
		}
		else {
			setCompanies([])
			let listNames = []
			data.listPlatforms
				.filter((p) => p.statusCode !== TYPERETURN.CompanyPlatformExpired)
				.forEach((platform) => {
					switch (platform.statusCode) {
						case TYPERETURN.CompanyPlatformThreeMonthsRemains:
							listNames = [
								...listNames,
								{
									ptfId: platform.ptfId,
									ptfNom: platform.ptfNom + ' (' + t('ExpiresIn') + ' 3 ' + t('Months') + ')',
								},
							]
							break
						case TYPERETURN.CompanyPlatformTwoMonthsRemains:
							listNames = [
								...listNames,
								{
									ptfId: platform.ptfId,
									ptfNom: platform.ptfNom + ' (' + t('ExpiresIn') + ' 2 ' + t('Months') + ')',
								},
							]
							break
						case TYPERETURN.CompanyPlatformOneMonthsRemains:
							listNames = [
								...listNames,
								{
									ptfId: platform.ptfId,
									ptfNom: platform.ptfNom + ' (' + t('ExpiresIn') + ' 1 ' + t('Months') + ')',
								},
							]
							break
						case TYPERETURN.CompanyPlatformOneMonthsPassed:
							listNames = [
								...listNames,
								{
									ptfId: platform.ptfId,
									ptfNom: platform.ptfNom + ' (' + t('ExpiredSince') + ' 1 ' + t('Months') + ')',
								},
							]
							break
						case TYPERETURN.CompanyPlatformTwoMonthsPassed:
							listNames = [
								...listNames,
								{
									ptfId: platform.ptfId,
									ptfNom: platform.ptfNom + ' (' + t('ExpiredSince') + ' 2 ' + t('Months') + ')',
								},
							]
							break
						case TYPERETURN.CompanyPlatformThreeMonthsPassed:
							listNames = [
								...listNames,
								{
									ptfId: platform.ptfId,
									ptfNom: platform.ptfNom + ' (' + t('ExpiredSince') + ' 3 ' + t('Months') + ')',
								},
							]
							break
						default:
							listNames = [...listNames, { ptfId: platform.ptfId, ptfNom: platform.ptfNom }]
							break
					}
				})
			setNamePlatforms(listNames)
		}
		if (data.autoSelect && data.listPlatforms[0]) {
			const platform = data.listPlatforms[0]
			setSelectedPlatform(platform.ptfId)
			const platformRoles = data.authRes.account.userPlatforms
				.find(p => p.platformId === platform.ptfId)?.accountTypes || []
			setRoles(platformRoles)
		}
	}, [data, t])

	const validate = (values) => {
		const errors = {}
		if (namePlatforms?.length > 1 && !values.platform) errors.platform = t('PleaseSelectAPlatform')
		if (roles.length > 1 && !values.role) errors.role = t('PleaseSelectARole')
		return errors
	}

	return (
		<SlidingForm
			direction="vertical"
			open={open}
			title={
				(!namePlatforms || namePlatforms.length === 1)
					? (!companies || companies.length < 2 ? t('roleChoice') : t('companyChoice'))
					: t('platformChoice')
			}
			iconAttachement={
				<>
					<FormIcon icon="clear" onClick={close} />
				</>
			}
			submitLabel="Valider"
			onClose={close}
		>
			<Form
				onSubmit={onSubmit}
				validate={validate}
				initialValues={getInitialValues()}
			>
				{
					companies?.length > 1 && (
						<InputSelect
							name="company"
							label={t('companyChoice')}
							onChange={handleCompanyChange}
							classes={{
								root: classes.select,
							}}
						>
							{companies &&
								companies.map((company, i) => {
									return (
										<SelectMenuItem key={i} value={company.id}>
											{company.nom}
										</SelectMenuItem>
									)
								})}
						</InputSelect>
					)
				}
				{namePlatforms?.length > 1 && (
					<InputSelect
						name="platform"
						label={t('platformChoice')}
						onChange={handlePlatformChange}
						value={selectedPlatform || (data?.autoSelect && data?.listPlatforms[0]?.ptfId) || ''}
						classes={{
							root: classes.select,
						}}
					>
						{namePlatforms &&
							namePlatforms.map((platform, i) => {
								return (
									<SelectMenuItem key={i} value={platform.ptfId}>
										{platform.ptfNom}
									</SelectMenuItem>
								)
							})}
					</InputSelect>
				)}
				{roles.length > 1 && (
					<InputSelect
						name="role"
						label={t('roleChoice')}
						disabled={!selectedPlatform}
						classes={{
							root: classes.select,
						}}
					>
						{roles.map((role, i) => (
							<SelectMenuItem key={i} value={role.code}>
								{t(role.code.toLowerCase())}
							</SelectMenuItem>
						))}
					</InputSelect>
				)}
				<FormButtonIcon type="submit" />
			</Form>
		</SlidingForm>
	)
}
PlatformChoiceForm.propTypes = {
	open: PropTypes.bool,
	close: PropTypes.func,
	data: PropTypes.object,
}
export default PlatformChoiceForm
